import { MessageCircle, Mail, Phone, MapPin } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import SocialLinks from "@/components/SocialLinks";

const Footer = ({ waLink }) => {
  const { t } = useLanguage();
  return (
  <footer className="border-t border-white/10 py-12" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex flex-col leading-none select-none">
            <span className="font-display font-extrabold tracking-[0.12em] text-xl">
              <span className="neon-text">X</span><span className="text-white">SALES</span>
            </span>
            <span className="flex items-center gap-2 mt-1.5">
              <span className="h-px w-5 bg-gradient-to-r from-neon-cyan to-neon-violet" />
              <span className="text-[9px] tracking-[0.32em] neon-text font-semibold whitespace-nowrap">AI COMPANY BUILDER</span>
              <span className="h-px w-5 bg-gradient-to-r from-neon-violet to-neon-magenta" />
            </span>
          </div>
          <p className="text-sm text-white/50 mt-3 max-w-sm">
            {t.footer.tagline}
          </p>
          <SocialLinks className="mt-5" />
        </div>

        <nav className="md:col-span-3 flex flex-col gap-3 text-sm text-white/60">
          <p className="text-xs font-bold tracking-[0.3em] uppercase text-white/40 mb-1">{t.footer.explore}</p>
          {t.nav.links.map((l) => (
            <a key={l.id} href={l.href} className="nav-link hover:text-neon-cyan transition-colors">{l.label}</a>
          ))}
        </nav>

        <div className="md:col-span-5 flex flex-col gap-3 text-sm text-white/70" data-testid="footer-contacts">
          <p className="text-xs font-bold tracking-[0.3em] uppercase text-white/40 mb-1">{t.footer.contacts}</p>
          <a
            href={waLink(t.common.waDefault)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="flex items-center gap-3 text-neon-cyan hover:text-white transition-colors"
          >
            <MessageCircle size={16} className="shrink-0" /> {t.footer.whatsappLabel}
          </a>
          <a href="tel:+41782042172" data-testid="footer-phone-ch" className="flex items-center gap-3 hover:text-neon-cyan transition-colors">
            <Phone size={16} className="shrink-0" /> +41 78 204 21 72
          </a>
          <a href="mailto:info@xsalesconsulting.com" data-testid="footer-email-link" className="flex items-center gap-3 hover:text-neon-cyan transition-colors">
            <Mail size={16} className="shrink-0" /> info@xsalesconsulting.com
          </a>
          <p className="flex items-start gap-3 text-white/50" data-testid="footer-address-ch">
            <MapPin size={16} className="shrink-0 mt-0.5" />
            <span>
              <strong className="text-white/80">XSALES CONSULTING LTD</strong><br />
              Via Cantonale 38, 6928 Manno TI, Svizzera<br />
              Tel/WhatsApp: +41 78 204 21 72
            </span>
          </p>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 mt-12 text-xs text-white/30">
        <p>{t.footer.rights}</p>
        <a href="/contatti" data-testid="footer-contatti-link" className="hover:text-neon-cyan transition-colors py-2">Contatti</a>
        <a href="/privacy" data-testid="footer-privacy-link" className="hover:text-neon-cyan transition-colors py-2">Privacy Policy</a>
        <a href="/cookie-policy" data-testid="footer-cookie-link" className="hover:text-neon-cyan transition-colors py-2">Cookie Policy</a>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
